import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as n } from "../../core/maybe.js";
var t = [0, 0];

function r(t, r) {
  return !!n(r) && f(t, r.x, r.y, r.z);
}

function i(n, t) {
  if (!t.points || t.points.length) return !1;

  var _iterator = _createForOfIteratorHelper(t.points),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _r = _step.value;
      if (!u(n, _r)) return !1;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return !0;
}

function o(n, t) {
  var r = t.xmin,
      i = t.ymin,
      o = t.zmin,
      u = t.xmax,
      e = t.ymax,
      c = t.zmax;
  return n.hasZ && t.hasZ ? f(n, r, i, o) && f(n, r, e, o) && f(n, u, e, o) && f(n, u, i, o) && f(n, r, i, c) && f(n, r, e, c) && f(n, u, e, c) && f(n, u, i, c) : f(n, r, i) && f(n, r, e) && f(n, u, e) && f(n, u, i);
}

function u(n, t) {
  return f(n, t[0], t[1]);
}

function e(n, t) {
  return f(n, t[0], t[1], t[2]);
}

function f(n, t, r, i) {
  return t >= n.xmin && t <= n.xmax && r >= n.ymin && r <= n.ymax && (null == i || !n.hasZ || i >= n.zmin && i <= n.zmax);
}

function c(n, r) {
  return t[1] = r.y, t[0] = r.x, m(n, t);
}

function m(n, t) {
  return s(n.rings, t);
}

function s(n, t) {
  if (!n) return !1;
  if (x(n)) return a(!1, n, t);
  var r = !1;

  for (var _i = 0, _o = n.length; _i < _o; _i++) {
    r = a(r, n[_i], t);
  }

  return r;
}

function x(n) {
  return !Array.isArray(n[0][0]);
}

function a(n, t, r) {
  var _r2 = _slicedToArray(r, 2),
      i = _r2[0],
      o = _r2[1];

  var u = n,
      e = 0;

  for (var _f = 0, _c = t.length; _f < _c; _f++) {
    e++, e === _c && (e = 0);

    var _t$_f = _slicedToArray(t[_f], 2),
        _n = _t$_f[0],
        _r3 = _t$_f[1],
        _t$e = _slicedToArray(t[e], 2),
        _m = _t$e[0],
        _s = _t$e[1];

    (_r3 < o && _s >= o || _s < o && _r3 >= o) && _n + (o - _r3) / (_s - _r3) * (_m - _n) < i && (u = !u);
  }

  return u;
}

export { u as extentContainsCoords2D, e as extentContainsCoords3D, o as extentContainsExtent, i as extentContainsMultipoint, r as extentContainsPoint, m as polygonContainsCoords, c as polygonContainsPoint };